import { WIDE_VIEWPORT_BREAKPOINT } from "@/constants/layout";

/**
 * Übersichtskarten: eine Spalte unter 900, zwei ab WIDE_VIEWPORT_BREAKPOINT.
 * Einzelfelder: zwei ab 900, vier ab 1200. 1280 ist nur die maximale Inhaltsbreite.
 */
export function caseOverviewColumns(width: number): { cards: 1 | 2; fields: 1 | 2 | 4 } {
  const fields: 1 | 2 | 4 =
    width >= 1200 ? 4 : width >= WIDE_VIEWPORT_BREAKPOINT ? 2 : 1;
  return { cards: fields === 1 ? 1 : 2, fields };
}
